import React from 'react';
import styled from 'styled-components';

import { ReactComponent as PauseIcon } from 'assets/icons/pause.svg';
import { ReactComponent as PlayIcon } from 'assets/icons/play.svg';
import PropTypes from 'prop-types';

import Button from '../../../../../components/Button';

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: start;
`;

const ButtonWrapper = styled(Button)`
  border-radius: 8px;
  background-color: ${({ toggled }) =>
    toggled ? 'var(--red-background)' : 'var(--yellow-background)'};
  color: ${({ toggled }) => (toggled ? 'var(--yellow)' : 'var(--red)')};
  border-color: ${({ toggled }) => (toggled ? 'var(--yellow)' : 'var(--red)')};

  :hover {
    background-color: ${({ toggled }) =>
      toggled ? 'var(--yellow-background)' : 'var(--red-background)'} !important;
  }

  svg {
    width: 14px !important;
  }
`;

const StreamEndCountdown = ({ value, onToggle }) => (
  <ButtonWrapper
    icon={value ? <PauseIcon /> : <PlayIcon />}
    onClick={() => onToggle(!value)}
    background={value ? 'yellow' : 'light-red'}
    toggled={value}
  >
    <TextGroup>
      <div className="text-extra-bold">{value ? 'Zatrzymaj czas' : 'Uruchom odlicznik'}</div>
      <div className="text-small">
        {value ? 'Wpłaty i suby wciąż będą doliczane' : 'Został on przez Ciebie wstrzymany'}
      </div>
    </TextGroup>
  </ButtonWrapper>
);

StreamEndCountdown.propTypes = {
  value: PropTypes.bool.isRequired,
  onToggle: PropTypes.func,
};

StreamEndCountdown.defaultProps = {
  onToggle: () => null,
};
export default StreamEndCountdown;
